import { render, staticRenderFns } from "./ProjectViewSidebarActivitiesCard.vue?vue&type=template&id=183e4156&scoped=true"
import script from "./ProjectViewSidebarActivitiesCard.vue?vue&type=script&lang=ts"
export * from "./ProjectViewSidebarActivitiesCard.vue?vue&type=script&lang=ts"
import style0 from "./ProjectViewSidebarActivitiesCard.vue?vue&type=style&index=0&id=183e4156&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "183e4156",
  null
  
)

export default component.exports